import { createEmptySliceBase, injectDetailSlice, toReducer } from '../sliceFactory';

const createOfficesReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'offices' });
  const withDetail = injectDetailSlice({ sliceBase });
  return toReducer(withDetail);
};

export default createOfficesReducer;
